import { AutocompleteRequestArgs, fetchAutocompleteResults } from 'app/providers';
import {
  optionsSelector,
  distribusionEnabledSelector,
  showStationSuggestionSelector,
  flixTrainSelector,
} from 'app/store/selectors';
import { reportAutocompleteError } from 'app/store/reducers/location';
import { AutocompleteResult, SearchMaskDirection } from 'app/models/types/store/location';
import { ThunkType } from 'app/hooks/appHooks';
import { retryAsync } from 'app/api/retryAsync';

export const fetchRequestTimeout =
  (
    requestArgs: AutocompleteRequestArgs,
    direction: SearchMaskDirection,
  ): ThunkType<Promise<AutocompleteResult[]>> =>
  async (dispatch) => {
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error('timeout')), 5000),
    );

    try {
      const result = await Promise.race([fetchAutocompleteResults(requestArgs), timeout]);
      return result;
    } catch (error: any) {
      const isTimeout = error.message === 'timeout';

      dispatch(
        reportAutocompleteError({
          id: 'error.autocomplete',
          level: isTimeout ? 'Request timed out.' : 'Failed to fetch results.',
          direction,
        }),
      );

      throw error;
    }
  };

export const requestAutocompleteWithRetry =
  ({
    query,
    departureCity,
    direction,
  }: {
    query: string;
    departureCity: string | null;
    direction: SearchMaskDirection;
  }): ThunkType<Promise<AutocompleteResult[]>> =>
  async (dispatch, getState) => {
    const state = getState();
    const { autocompleteUrl, locale } = optionsSelector(state);
    const distribusionEnabled: boolean = distribusionEnabledSelector(state);
    const delayBetweenRetries = 1000;
    const showStationSuggestions: boolean = showStationSuggestionSelector(state);
    const isFlixTrainDomain: boolean = flixTrainSelector(state);

    const requestArgs: AutocompleteRequestArgs = {
      autocompleteUrl,
      query: encodeURIComponent(query),
      locale,
      flixbusCitiesOnly: !distribusionEnabled,
      departureCity,
      isFlixTrainDomain,
      showStationSuggestions,
      popularStationsCount: null,
    };

    return await retryAsync(
      async () => dispatch(fetchRequestTimeout(requestArgs, direction)),
      3,
      delayBetweenRetries,
    );
  };
